// extracted by mini-css-extract-plugin
module.exports = {"controls":"ExpandableControls_controls__WgZL5"};